import "./App.css";
import { Route, Routes } from "react-router-dom";
import Login from "../src/features/auth/Login";
import axios from "axios";
import { Unauthorized } from "./components/helper/HelperTwo";
import { ProtectedRoute } from "../src/Context/HelperOne"
import Test from "./components/test/Test";
import RoleCreate from "./components/admin/role/RoleCreate";
import {
  employeePermission,
  roleCreatePermission,
} from "./components/helper/HelperThree";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Employee from "./components/admin/employee/Employee";
import Roles from "./components/admin/role/Role";
import RoleAssign from "./components/admin/roleAssign/RoleAssign";
import ForgetPassword from "../src/features/auth/ForgetPassword";
import ResetPassword from "../src/features/auth/ResetPassword";

import Dashboard from "./components/admin/dashboard/Dashboard";
import Customer from "./components/admin/customer/Customer";
import Plan from "./components/admin/plan/Plan";
import Group from "./components/admin/group/Group";
import ActivePlan from "./components/admin/activeplan/ActivePlan";
import ChitDetails from "./components/admin/chitdetails/ChitDetails";
import MonthlyAmountEntry from "./components/admin/MonthlyAmountEntry/MonthlyAmountEntry";
import Payout from "./components/admin/PayOut/Payout";
import Payment from "./components/admin/Payment/Payment";
import Loan from "./components/admin/loan/Loan";
import FinanceCustomer from "./components/admin/financecustomer/FinanceCustomer";






// axios.defaults.baseURL = "http://localhost/arun/ramchit/lRamChits/";
// axios.defaults.baseURL = "http://localhost/pradeep/ss_ram_chits/lRamChits/";
axios.defaults.baseURL = "https://sschitfunds.com/api/1/";



function App() {
  return (
    <div>
      <ToastContainer />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/crm/forgot/password" element={<ForgetPassword />} />
        <Route path="/crm/reset/password/:id" element={<ResetPassword />} />

        <Route path="/crm/dashboard" element={<Dashboard />} />
        {/* <Route path="/crm/dashboard" element={
          <ProtectedRoute
            element={<Dashboard />}
            allowed={true}
          />
        } /> */}

        <Route path="/crm/customer" element={<Customer />} />
        <Route path="/crm/plan" element={<Plan />} />
        <Route path="/crm/group" element={<Group />} />
        <Route path="/crm/active/plan" element={<ActivePlan />} />
        <Route path="/crm/chit/details" element={<ChitDetails />} />
        <Route path="/crm/payout" element={<Payout />} />
        <Route path="/crm/loan" element={<Loan />} />
        <Route path="/crm/finance/customer" element={<FinanceCustomer />} />

        <Route path="/crm/monthly/amount/entry" element={<MonthlyAmountEntry />} />
        <Route path="/crm/payment" element={<Payment />} />

        <Route
          path="/crm/employees"
          element={
            <ProtectedRoute
              element={<Employee />}
              allowed={employeePermission()}
            />
          }
        />

        <Route
          path="/crm/roles"
          element={
            <ProtectedRoute
              element={<Roles />}
              allowed={roleCreatePermission()}
            />
          }
        />
        <Route
          path="/crm/roles/assign"
          element={
            <ProtectedRoute
              element={<RoleAssign />}
              allowed={roleCreatePermission()}
            />
          }
        />

        
        {/* <Route
          path="/crm/employee/designation"
          element={
            <ProtectedRoute
              element={<EmployeeDesignation />}
              allowed={employeePermission()}
            />
          }
        /> */}
        {/* <Route
            path="/crm/employee/department"
            element={
              <ProtectedRoute
                element={<EmployeeDepartment />}
                allowed={employeePermission()}
              />
            }
          /> */}


        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="/role/create" element={<RoleCreate />} />
        <Route path="/test" element={<Test />} />
      </Routes>
    </div>
  );
}

export default App;
